import React, { useEffect, useState } from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useImports } from '../../Data/Imports';
import Loading, { PageLoading } from '../../Components/Loading';
import NoItems from '../../Components/EmptyStates/NoItems';
import NewImport from './NewImport';
import Grid from '../../Components/Formatting/Grid';
import ButtonRow from '../../Components/Button/ButtonRow';
import { useNewWindow } from '../../Services/helpers';
import Button from '../../Components/Button/Button';
import Icon from '../../Components/Icons/Icon';

let refreshTimeout = null;

const Imports = () => {
    const {imports, refresh} = useImports(true);
    const [newImport, setNewImport] = useState(false);

    return <>
        <TopBar left="/more" title="Imports" />
        <Page>
            {imports ? <Inner {...{imports, refresh, setNewImport}} /> : <PageLoading />}
        </Page>

        <NewImport isOpen={newImport} setIsOpen={setNewImport} onNewImport={refresh} />
    </>
}

const Inner = ({imports, refresh, setNewImport}) => {
    const newWindow = useNewWindow();
    useEffect(() => {
        imports.forEach(importItem => {
            if (importItem.stage === 'Complete') {
                return;
            }

            clearTimeout(refreshTimeout);
            refreshTimeout = setTimeout(() => {
                refresh();
            }, 5000);
        })
        return () => clearTimeout(refreshTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imports]);

    return <>
        <div className="flex flex-col divide-y w-full pb-5">
            {imports.map((importItem, i) => {
                return <div key={i} className="flex flex-row justify-between py-2">
                    <div className="shrink-0 p-2">
                        {importItem.stage === 'Complete' ?
                            <Icon icon="Check" className="fill-brand" theme="solid" size="3x" /> :
                            <Loading size="3x" />
                        }
                    </div>
                    <div className="grow ml-4">
                        {(importItem?.stage === 'Customers' && !importItem.progress?.Customers) &&
                            <div className="text-sm text-muted">
                                Analysing your CSV.<br />
                                This might take a few minutes.
                            </div>
                        }

                        <Grid items={[
                            [
                                <strong>Total</strong>,
                                importItem?.progress?.Customers?.total,
                                !!importItem?.progress?.Customers?.total,
                            ],
                            [
                                <strong>Failed</strong>,
                                importItem?.progress?.Customers?.failed,
                                !!importItem?.progress?.Customers?.failed,
                            ],
                            [
                                <strong>Blocked</strong>,
                                importItem?.progress?.Customers?.blocked,
                                !!importItem?.progress?.Customers?.blocked,
                            ],
                            [
                                <strong>Ignored</strong>,
                                importItem?.progress?.Customers?.ignored,
                                !!importItem?.progress?.Customers?.ignored,
                            ],
                            [
                                <strong>Matched</strong>,
                                importItem?.progress?.Customers?.matched,
                                !!importItem?.progress?.Customers?.matched,
                            ],
                            [
                                <strong>Imported</strong>,
                                importItem?.progress?.Customers?.imported,
                                !!importItem?.progress?.Customers?.imported,
                            ],
                        ]} />

                        <ButtonRow arrange="left">
                            {importItem.exports && importItem.exports.map((exportItem, i) => {
                                if (exportItem.count === 0) {
                                    return null;
                                }
                                return <Button key={i}
                                    theme="primary"
                                    label={exportItem.title}
                                    icon="CloudArrowDown"
                                    onClick={() => newWindow(exportItem.url)}
                                />
                            })}
                        </ButtonRow>
                    </div>
                </div>
            })}

            <NoItems
                title="New import"
                message={<>
                    Upload any CSV with customer data.<br />
                    Our AI will analyse it and import the customers into your account.
                </>}
                icon="CloudArrowUp"
                onClick={() => setNewImport(true)}
            />
        </div>
    </>
}

export default Imports;
